import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
//widgets
import withStyles from '@material-ui/core/styles/withStyles';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
//local
import Transition from './Transition';
import {
  dialog,
  dialogHeader,
  defaultFont,
  warningCardHeader,
  successCardHeader,
  dangerCardHeader,
  infoCardHeader,
  primaryCardHeader,
  roseCardHeader,
} from '../styles';

function CustomDialog({ ...props }) {
  const {
    classes,
    titleColor,
    plainDialog,
    open,
    title,
    subtitle,
    content,
    footer,
    ...rest
  } = props;
  const plainDialogClasses = clsx({
    [' ' + classes.dialogPlain]: plainDialog,
  });
  const dialogPlainHeaderClasses = clsx({
    [' ' + classes.dialogPlainHeader]: plainDialog,
  });
  const randomNumber = Math.random().toString(36).substr(2, 5);
  return (
    <Dialog
      open={open || false}
      className={classes.dialog + plainDialogClasses}
      TransitionComponent={Transition}
      aria-labelledby={'dialog' + randomNumber}
      PaperProps={{
        classes: {
          root: classes.dialogPaper,
        },
      }}
      {...rest}
    >
      <DialogTitle
        id={'dialog' + randomNumber}
        classes={{
          root:
            classes.dialogHeader +
            ' ' +
            classes[titleColor + 'DialogHeader'] +
            dialogPlainHeaderClasses,
        }}
      >
        <div className={classes.dialogTitle}>{title}</div>
        {subtitle !== undefined ? (
          <small className={classes.dialogSubtitle}>{subtitle}</small>
        ) : null}
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>{content}</DialogContent>
      {footer !== undefined ? (
        <DialogActions className={classes.dialogActions}>
          {footer}
        </DialogActions>
      ) : null}
    </Dialog>
  );
}

CustomDialog.defaultProps = {
  titleColor: 'warning',
};

CustomDialog.propTypes = {
  plainDialog: PropTypes.bool,
  classes: PropTypes.object.isRequired,
  titleColor: PropTypes.oneOf([
    'warning',
    'success',
    'danger',
    'info',
    'primary',
    'rose',
  ]),
  dialogTitle: PropTypes.node,
  dialogSubtitle: PropTypes.node,
  content: PropTypes.node,
  footer: PropTypes.node,
};

const customDialogStyle = {
  dialog,
  dialogPlain: {
    background: 'transparent',
    boxShadow: 'none',
  },
  dialogPaper: {
    maxHeight: 'calc(100vh - 96px)',
    overflowY: 'visible',
  },
  dialogHeader: {
    ...dialogHeader,
    ...defaultFont,
  },
  dialogPlainHeader: {
    marginLeft: 0,
    marginRight: 0,
  },
  warningDialogHeader: {
    ...warningCardHeader,
  },
  successDialogHeader: {
    ...successCardHeader,
  },
  dangerDialogHeader: {
    ...dangerCardHeader,
  },
  infoDialogHeader: {
    ...infoCardHeader,
  },
  primaryDialogHeader: {
    ...primaryCardHeader,
  },
  roseDialogHeader: {
    ...roseCardHeader,
  },
  dialogTitle: {
    color: '#FFFFFF',
    marginTop: '0',
    ...defaultFont,
    fontSize: '1.3125rem',
  },
  dialogSubtitle: {
    ...defaultFont,
    marginBottom: '0',
    color: 'rgba(255, 255, 255, 0.62)',
    margin: '0 0 10px',
  },
  dialogActions: {
    padding: '0 14px 10px 14px',
    marginTop: '0',
  },
  dialogContent: {
    padding: '12px 24px 24px 24px',
    minHeight: '60px',
  },
};

export default withStyles(customDialogStyle)(CustomDialog);
